import React from "react";
import InputMask from "react-input-mask";

// Campo com rotulo visivel e associado ao input (htmlFor/id), usando os
// estilos .field do design system. Props extras (ex.: inputMode) vao pro input.
const IFTA = ({ id, text, value, onChange, mask, ...inputProps }) => {
  return (
    <div className="field">
      <label className="field-label" htmlFor={id}>
        {text}
      </label>
      <InputMask
        id={id}
        className="field-input"
        type="text"
        mask={mask}
        value={value}
        onChange={onChange}
        {...inputProps}
      />
    </div>
  );
};

export default IFTA;
